require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-برنامج-تسجيل-صوت.json") })
        }
      }, "path---tags-برنامج-تسجيل-صوت");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-برنامج-تسجيل-صوت!./.cache/json/tags-برنامج-تسجيل-صوت.json
// module id = 587
// module chunks = 231608221292675